// src/PurchaseCredits.js
import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { loadStripe } from "@stripe/stripe-js";

// Replace with your actual Stripe publishable key.
const stripePromise = loadStripe("pk_live_51Qo0vbECXBbNDUVkvZZmOJSFHfZLULlkzFihVAhjeBCNxqjpcOBDccONkLWcZ056bjXgMhZzwcG6M6su7LJWonka00Rrm7FAFe");

const PurchaseCredits = () => {

  const [loading10, setLoading10] = useState(false);
  const [loading100, setLoading100] = useState(false);


  // A helper function that creates a checkout session and redirects to Stripe.
  const handleBuyCredits = async (priceId) => {

    if (priceId == "price_1Qo1BwECXBbNDUVkFlssgAQj") {
      setLoading10(true)
    } else if (priceId == "price_1Qr49MECXBbNDUVkHHEP9FnK") {
      setLoading100(true)
    }

    const functions = getFunctions(undefined, "us-central1");
    const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");

    try {
      // Call the cloud function with the provided priceId.
      const { data } = await createCheckoutSession({ priceId });
      const sessionId = data.sessionId;

      const stripe = await stripePromise;
      const { error } = await stripe.redirectToCheckout({ sessionId });
      if (error) {
        console.error("Stripe Checkout redirection error:", error);
        setLoading10(false)
        setLoading100(false)
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
      setLoading10(false)
      setLoading100(false)
    }
    setLoading10(false)
    setLoading100(false)
  };

  return (
    <div className="ml-0 md:ml-0 flex-1 flex flex-col justify-start bg-gray-50">
      <div className="w-full max-w-3xl rounded-lg space-y-6 md:space-y-8 mr-auto ml-0">
        <h2 className="text-xl md:text-2xl font-semibold font-ubuntu tracking-wider ml-12 md:ml-0 mt-1 md:mt-0 mb-8 md:mb-auto">
          Buy lesson credits
        </h2>
        <p className="mb-8">You need credits to generate lessons. 1 lesson costs 1 credit.</p>

        <div className="flex flex-col md:flex-row gap-10">
          {/* 10 lesson plans card */}
          <div className="bg-gray-800 rounded-lg p-6 flex flex-col justify-between w-auto md:w-[260px]">
            <div>
              <h3 className="text-xl font-semibold mb-4 text-white">10 lesson plans</h3>
              <div className="flex items-baseline space-x-1 text-2xl font-bold text-white">
                <span>$10</span>
                <span className="text-sm font-normal">USD</span>
              </div>
              <p className="mt-4 text-gray-300">
                $1 per lesson. <br className="hidden md:block"/>One-time payment. <br className="hidden md:block"/>No subscription.
              </p>
            </div>
            <button 
              onClick={() => handleBuyCredits("price_1Qo1BwECXBbNDUVkFlssgAQj")}
              className="flex flex-row items-center gap-x-2 justify-center mt-6 bg-yellow-400 hover:bg-yellow-600 hover:text-white transition font-semibold py-2 px-4 rounded"
              disabled={loading10 || loading100}
            >
              <span className={`${loading10 ? 'opacity-0' : 'opacity-100'}`}>Get Credits</span>
              <div className={`absolute w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin ${loading10 ? 'opacity-100' : 'opacity-0'}`}></div>
            </button>
          </div>

          {/* 100 lesson plans card */}
          <div className="relative bg-gray-800 rounded-lg p-6 flex flex-col justify-between outline outline-4 outline-yellow-400 w-auto md:w-[260px]">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-xs uppercase font-semibold px-2 py-1 rounded shadow whitespace-nowrap">
              Insanely Great Deal!
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4 text-white">100 lesson plans</h3>
              <div className="flex items-baseline space-x-1 text-2xl font-bold text-white">
                <span className="line-through text-gray-400 mr-2">$100</span>
                <span>$40</span>
                <span className="text-sm font-normal">USD</span>
              </div>
              <p className="mt-4 text-gray-300">
                40¢ per lesson. <br className="hidden md:block"/>One-time payment. <br className="hidden md:block"/>No subscription.
              </p>
            </div>
            <button 
              onClick={() => handleBuyCredits("price_1Qr49MECXBbNDUVkHHEP9FnK")}
              className="relative flex flex-row items-center gap-x-2 justify-center text-white mt-6 animated-gradient-bg font-semibold py-2 px-4 rounded transition overflow-hidden"
              disabled={loading10 || loading100}
            >
              <div className="absolute inset-0 bg-white opacity-0 hover:opacity-30 transition"></div>
              <span className={`${loading100 ? 'opacity-0' : 'opacity-100'}`}>Get Credits</span>
              <div className={`absolute w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin ${loading100 ? 'opacity-100' : 'opacity-0'}`}></div>
            </button>
          </div>
        </div>

        <ul className="space-y-2 mt-6 py-4 md:py-0">
          {[
            "Pay-as-you-go, no subscription!",
            "Detailed teaching instructions",
            "Lesson, PDF worksheet, activity and homework in each plan",
            "Plans based on your prompts",
            "Plans based on your textbook photos",
            "🇬🇧 British or 🇺🇸 American English",
            "You can edit content before printing"
          ].map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="text-[#a7c957]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6 mr-2"
                >
                  <path
                    fillRule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PurchaseCredits;
